<template>
  <div class="retail-navbar">
    <!-- <div class="comming-soon-section">
          <div class="comming-soon-tag">
            COMING <br />
            SOON
          </div>
          Head's Up : Launching up Options soon on StockAnts. STAY TUNED!
          <div class="comming-soon-tag">
            COMING <br />
            SOON
          </div>
        </div> -->

    <div id="overlay" @click="toggleTopNav()"></div>
    <div class="navbar-container">
      <!-- <div class="navbar-menu-section-desktop-view"> -->
      <div class="toggleBtn">
        <div @click="toggleTopNav()" class="right-margin-15" style="cursor: pointer">☰</div>
        <div class="flex-space-between" style="width: 100%">
          <div class="flex">
            <!-- @click="$router.push({ path: '/retail-investors' })" -->
            <img src="../../assets/images/logo/logo1.png" class="cursor-pointer navbar-logo" style="margin: 0" />

            <img v-if="currentEnvironment.logo" :style="[currentEnvironment.width ? { width: currentEnvironment.width } : {}]" :src="currentEnvironment.logo" class="cursor-pointer navbar-logo broker-logo" />
          </div>
          <div class="flex">
            <div v-if="currentEnvironment && currentEnvironment.loginModule != 'BlinkX'">
              <div id="backButton" @click="goToPaytmMoney()" v-if="paytmSource == 'app' && userProfile.utm_source == 'Paytm Money'">
                <!-- && userProfile.utm_source == 'Paytm Money' -->
                <i class="el-icon-d-arrow-left" style="font-weight: 700; font-size: 20px"></i>
                <span style="font-size: 12px"></span>
                <img src="https://static.paytmmoney.com/android-chrome-192x192.png" width="22px" alt="" style="margin-left: 5px" />
              </div>

              <button v-if="!userProfile && paytmSource != 'app' && currentEnvironment && currentEnvironment.utm_source != 'Nirman'" class="signup-btn btn-secondary-theme-filled" @click="currentUrl.includes('paytmmoney.stockants.com') || currentUrl.includes('nuvama.stockants.com') || currentUrl.includes('zebuetrade.stockants.com') || currentUrl.includes('aliceblue.stockants.com') || currentUrl.includes('rupeezy.stockants.com') || currentUrl.includes('enrichmoney.stockants.com') || currentUrl.includes('fyers.stockants.com') || currentUrl.includes('bajajbroking.stockants.com') || currentUrl.includes('almondz.stockants.com') || currentUrl.includes('almondztrade.stockants.com') || currentUrl.includes('hdfcsky.stockants.com') || currentUrl.includes('shareindia-trade.stockants.com') ? getRedirectURLForBroker() : login('signUp')" style="margin: 0">
                {{ websiteUserType.userType == 'broker' ? 'Login' : 'Sign Up' }}
              </button>
              <div v-else-if="!userProfile && currentEnvironment && currentEnvironment.utm_source == 'Nirman'">
                <form method="POST" target="_self" contentType="application/x-www-form-urlencoded" action="https://trade.nirmanbroking.com:3000/interactive/thirdparty" dataType="application/x-www-form-urlencoded">
                  <img
                    style="visibility: hidden; width: 0px"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABGdBTUEAALGPC/xhBQAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAACZ1SURBVHhe5Xt3XFRn1y3DwABDB0UEsWti7yJir8SGBbvGGlti7D1RY6LGWGOPvVfsiIBiBQUBAQGlKUWKNOkwfd31DPp+n/L+ftf7782RzTlzzpRnrb332nufEYOKrfVktL9pBTT8S+wDTWCWCQJ2fTz5b7Q/BQH/Js9/aQWCgP924V9j1QgYseUCvHZexvid1zBh101M2nMbM/f7YdbBu5h35D7mHw3ComPPsPTUc6w8HYE156OxlvbbxRhsPB+HLZde46/L8dh2OQG7Lidh1/U32HkzDXtupePA7QwcupONI37ZOOabi5MBOThz9wPOBRbj/MNyeD+ugPcTFa4JC1LiRrAS14MUuPlMjVshOvhFaBAQqcG9aB38X6irjI/9nmvhF8brYRr4R+hwNxK4HwMEvlAhKEaFkFdKvMzQIjlH/RlWYdUIGLXt0kcCrusJmLz3Nmbs88cPBwIw92AgSXiIhUefYsmxUD0Bq8+8wK/norD+/EtsvPQKm7zjSUACtl5JwM5rydh19S12XH2D3Z8I8MnA4dtZOEIijvvm4+y9Epy5V47zgQpcfKDG5YdamgZXH+pw5bGO4EHwGtwOV5MA5f8A/18E+IcC/s8BP+7vvdDRgIcvgZDXQFQyEJMOJGYDydmqz7AKq0aA55/n9CSM2XEV43fcwMTdPpi2/46egHn/BOLHo4+w6Cgj4ORzLD1eRcIvZ6Ox/lw01l2Iwe8X47CJRGy++ApbvROw/UoiiUihvcVeRsKBW+9w8FYGTvjn4ZRfEU4HfMBp/wIC0SIgWourwQp6XoXrwTx+DNwIIgHPSUCEQu/9T8DvhKu4JyEiAgQBtLvPGRnPFXgQrcLTBCA6RYvETB3SCoDsQiCzUPsZVmHVCBi+5fz/ELDzBiaRgOl7/ZgG/oyAe5grIuDIUyw+EYLlJ8Kw4lQ41pyJwjpGwa8XX+K3S3H4gyRsFqlAAnZcSaoi4HrKfwg45JOJo77vcex2LknIQeArFXZfjcDWcw9xNTwNwSlK+ISTiCBNFQEM/9v0fkDk/3j+TjjBR2lxlxYYxpCPoPH6o5cKhCSq8SKNHs+sRHqBBrnlQLkKKNXgM6zC/isBXnoCrjECqAG7b2Pa3juYSRLm7L9LEh5g/uFgLD4egiWMgOXHn5OASH0arKGtu/ASGy7G6lNBRMC2K8kEn4pd11KxjwQcvCkIyNATcOjGe/hFKbHhWACkFvaQmMlhZGkJz/mr8fgNSaBHrweDaaDjsUofAX4E7xdRZf5RGua7Fo+Y80+idHgSrUB4kgrR6VrE5wNZRZUoqFCjTAcoAFTqNJ9hFVadgK0XMHzHRYze5Y1xuymEu5kGe29h8n6mwqE7mHX4HlOBJOgj4TGJCMKKk8+w6nQ4Vp0lERTD30jAH95CD6gFV+Ox2zsaO2+9xE7fWOy98xpHGAWnb+bjkm8FbjwrhryxKwwsrGHRwAWGFqaQmVsh+HUpfEmA0ABfitm96FKKXCUBqxH4UoP7L1V4GKPB49dahCZp8TxZg/A3CsRmqBBPsXubp0V2URlKVWoQP1Q6HdS6r0iBoVvOkgBWgh2XMW4Xo2DPdUzcRzEkAVNJwMzDAZhziFpw+AF+ph4sOf4Ey06SBFaFVRTEXyiG6y9RC5gKm1gNtni/xg7vJGy9kYpttzOx804G9t/JxOFbb3A7NA97rj6DobwmjByboFbtFmjbsgekMjNMnf8XYihcPiEM7SggKE6LxzFqPI3TIZT5HUZxC3urw4tUCl2all7X4VWWGonv1UjJ1yK9WIvc0nIUK9TQkgANWdDx35d4qxEw5M8z8NzKNNh+CaO3e2PMzisY9zcjYc8NTP3nDqYf8sdsiuHcI4H46cgDLDxGAk6JKKAmnHzBsviCelCVBr9fisWf3onYdCUTW66VYPt1JXb6FGO/bxL2BGRi2yOGeGgJatSsCQdHUxgYSdF97CR07e+Jddsv4OU7qjnBB7OkhVPRI5MZ3ikaxKZp8DqLyv4eSMoB4gXwHBVS8zU0NbIKNcgrA/KZ+MVKLUrUWqjIgppEfIn3vxOw7TxGbmMa7PDG+N2MgL039TZ5/y18f+AOZuwPYCqwLP5zj3rwEItOPmJFeMYoEAR87AuoBZsuJeKPK+HY7H8fO3zicOB6Di74sb7fq8SVexW4wjr/NKEE8poNYORgBQN7I8gaOEBu6YjH0bkIS9QhJFaHqEQg4S3Bplcg7b0KmVT1vFIt8ku5p8BlFqqR8UGcr0QujwtLNCjk9Q9M/JxyJYoqmfsUQP58hlXY/5WAT96vIsAHU0jAdIrhzMN39ZHwI6Ng/vHHWHTiSwJiSICIghRsv1aOwzfT8fBRPK6fP4YLp9bh6YUfUXJhLDYsHg6piTUM5M0gq9kEUqkMPy7ZQfHS4WlsMaJTK5DJfC6voAfpRaayPqe1/KWmib0AV073EivKK7VQVDLnK3Uo5vmcMhVJUqOcT/x/ImAUCRgjIuAjAcImMQIEAdP+uYsZtJlMg3nHqAUnKIYsi6tORuDX85H6SvAbteB3psGGy8z3+0rcCU7C+qWjML6zDCO/NcDaLgbI+8kQMQtssGOwPayNJTCQGKJWmwHILVGxgVEik/JdSoBKihcljMsXyEmARkARmzgnRE6nz3OxFz964wlmATLKNMgoLAcD4utSYPDm03oN8Nx6ESN2UAdIgPD+lIO+mHbAlwT4MwLYF5CA2RTDuYcYAdSBpSceYN6ZGMw/l4Z1p0KxlG3wn2xzHwVn4Piev9Gzkx0a1JCgvZMhOjhLMKqdGU4Pt0P2AltoNpgieZIEa0e1xbviMqQyxDMVCj0OaLls/ujAukYiNCIM9Jv+KjdBxifUn85VbYIaUQKLGSqFWi1yWBG+xFuNgGF/ncNIlsERrALCxu25ie8PsgL844cZBwn+IDXgYABTgE3RP/eZAg+xmPPB8pN3sfQ0W+TTCVh3JhT7AuNx+Px9eLbvhPY1jOH2rQTtmsnh4uCAGtbWsLY2gEdbOQ6NtUTpUgl06w3xflNTVIYfJWal3qNKLcGVVfn2EzgNgajVwpdfs2n4Kh2YGSjiyzOUX9EKj9h+EV7sAUb+fYX7a5i8j2FP9Z/BCBAVYOaBKu/PYv7PO3Sfg5HoBZ5i2dkn+P20LzacCcEft5Lwz5Hd8HAyRf+6RhjQyRqNXSQwtZTAtoYT7OwbwNzGFvZNjNG/izF8lthB/bcddNuNUb7PDuWhm/WeZ/Omhx0U4ovXCZT9j5tOCMFXbR9Jo1FCUMA3/BLvfyVgFIehsTvZCjPv9aFPr8/8h+Xv0F3MOSIaIXr+KEsge4AlJ59iFUN+0dkwrLv4DGvPvcDe0CKsmT0QY2oZoFcDG8iMDGFsbIwazvXY8ZnAzskSTb6xQ/0GctRxkmCiqzES/2wK3Z7aJEGGkiP1oc7lNMNt5/EDqNO0MTq7DUNhUZH+3JebiBHha9HsfDK1niQaf4RYljNyOAp8hlVYNQJGMu9HMQLG7L6CScz9qcx7AX4WvT7/KMfhYw/xM3N+yamnWHHmGdvfCE6CHIu9o/DLzVR6Pxvn/cOwaEgd9LQzgMzQEI2bDcG+oy+QVVCGBi3qolE9CQZ3kGEoU6JHczu0t5Hg1KQaKNvXBiUbXZD7pxyaxFN6cJevHoOxzBQ2tnZQKkUwE+x/RLBqE49EvquoEZ9MCCcVg1GkI3imAKsAG8TPsAqrRsBohv7YvewA2QJPOcBR+BDr/WE2PQS/6NQTLDrzFMvPPcfqCxFYeykKG67EYPP1eOy4EYk/fDNx+pkCp5dOx7T6EjQ1N8Lvf2xGfJEYXIAUJuLwEf3R2sIAk5qYYGQLmpsTfh5QGxtcDZG+tjZToSlilznh8MTa9J4CRzcdhZmJKS7fPl2Flt78kgCRKkpeUBCyUA9hAniZRoECdQWyVUpkUU9See5LvNUIEK3v+P0Uvn0+mLmPYzDz/keWukXHH2AxW96V9Pq6C+Gc+l5g4+WX7PVj2ecnsr9/jYOc92/EVmLLlAYYIjfAhvnT8a5UBd+oCvjHKJCcB5w7dgUNTaWY1EKOSe1rY2QzGX77zhGXJ1ghYo4R4F0PAQvaw1pmiPVzO+EbM3u4tmnGei+Ej5KmE3BFWawqfYIKsf+UBhUa9vskSeS8gq+pJPAyWqFGiXxdxWdYhVUjYOr+2+z2fNnt+bLRCaDKB2IBw34Z830F8/2Xs6HYdDYcf16MxFZGwI4rcdjnk4jDPmk4zbLnG16KVeMs4EUvP74ZgDBWr5BYIJQNzetcjqS5Cng2q4MxDSSY0sICy3pYYZWrFc55uSBhJb1+9RvsGdcAJrKmqOtoACtjI4SHcibWb4IEFf+xMWKOizpfTNDC25/IqFCrOPV97BpIhN4+7gRtX+KtRsAsCt1slrg53OvBs8lZdjIYK84+Zb6HYi29v/FiFP5i6G+j93fdfI0Dt99g790UnH+qQtD9GKxtK8OVoXKkvczGI4KOecPBhfsQzujCkd5Lp2BuTQOscJNgy9BaODaxBjZ3kcFnjA2097/D+uH1IZMawVRmgGWTZ+hVX8eqIEAIYGK0zSmuRFa5BpmVahRw4BGNTpUWkA4dW0FR/P4XAaJ9KOMLv8RbjYA5Ytxlm/uT3vMMexKw9FQwVp8NYVcXiY0cbYX3/yL47dfi8PeNeD0BewJJwDMV7nv74JeGxgia1x4l2ZXwS1EjMqkczzKBVC6gsrAEGzvb4xc2RcubSnBiZC3sHuQA76m1cWyoBFlHG+P92wfo0tINe/au/w8AhYYgSYQAKpqbt+z9kws49+dq8bYEyCbeEp6vEGTpXyHoEKJZFR/C++LRl3irEbBA3PikLWSZWyS8T+FbQQLWiPp+OYqTXTQ2M/dFBOy4Hodd119jz41ETneJ8I9VYtzImWhnJcP8rg0RGVGI0HcavEhSISSealyhxLpp/bDNTYZbfV1wsHVN7OlkhaND7fFXH2sELmNHeLq1ftGfNj0YzrJC4Djo4R0F9fX7CiRQT16yNQhP0yEsXY3obJ0+xVI+cAok0WIQEjdAFHyvMsZFKd9J6MKXeKsRsJxghS2j2AnBW33+OcOeNZ722zna+XAOOZGc82Pw1zURBa+wmwTsYyrcCErHxiOPIHeUoVGzjnCp0wtvslR4HMdFFQK3z5xDd2spljeX4HLv2oidWA9nehni8FBbTHWW4p9BMpQGLeVShSsVKOZO5LmI+3L+4qiP+LxKPEsqQjjn/2ecEJ8k0RK0CE7g8JQMPIhTIjBWpb8Wl65CQqYaySQmnpZY/BUE/EqgAvBagv31wnM2NxGc7SP0wNfz3B/cb+TjLdSBrd4vseNqDKMgHru8YxEQU4hB87bBwMAAds374vvZm/EkrBR3IziN0S075g3EEjdD/NXdCuuaWCByoiViJtbCo0GW+LunDNPqyaDMDhGQGb2VKFJqSILIf9ZxqnsGAbzN0yE2S4fQFODxGy3uJahxO0aD65EKXH5ehgsh5TgdXIbLUTrcDNPB9wVJeQ3cY3QGJ3xFKyxK3PqLLHMEuoHHvxPs7+eF58OY/1H4kxrwlxBBUQX0BMQyFYQYJmC/XyIuhqSg14T56O81D/fDilgVNLgfr4Wf/32M626NRX0NMbOVKQbamWFoQxn+GdcXVwY1xtl+RlgxtCHBVoW/jmqp4PBSShIYzcgv13Es1uDNe3qWeiIIePRWi7uJSlyNBrhknAxW4EyIBudDdaBk4XSoCpdI/u0oFR6J7wbSvuKW2AY2OL+zu9tI8JtY6zd7U/hEzb8Ugc38pG1XXmIX8/9vCuAu0QNwv5fh//e1eOz3ScHxe8kISq/E4yQFbj8pxrn7xbiRqMUh71f6js7EVAJjqQEa1LbEwh1nYOzUGEYyGaY3cUPEmf168Gp6u1xJ8JVKDkRAoQD/oQJJOeV4lalFdCoQLMI9EbjD9LpOsMKusFpeeqLF5WA1Lj0VX5IU4dnrSqYCqwW1oYwi8CXeagT8QQI2koAtrPHb6e0d9PI2HgsT3t5NwLuvvsIegt5z4zXz/5WegH3UAfGtz/6bSTjqm4ST/mk445+Lc4F5OPUoBwkFOnToPoszvxEM7K1gVdcRs2bNRu/JP8LAqA6MTRvhAysEIx65Jcz3AgWy80pQomILW6RAZn4JkvMrEZuuQFiyhuFc9e2P6DD9QzUIjBD3DHUIISlhjI6wt2okvKtEAUuDuB2mF1MhLV/grUbADorbtksvsfNKLPZcJziq/G7a3xS7/bcY5gz1fSx9Yn/QJ0lv4lgAP+iTjgM3U3Dw1hscvp2OQz5ZOH47CWd94hAYrsKav67CwJAEONhAaibDrxyC1nZrBWsjGxhYy9HEazEqOblkFJAE5nt+qQ4lrF2ioJEHdnYcaTnRRCZWIiSmAvfCP+BB5AfEsQ6msA6+52vyKjT6cljIkZktgh64sKrtK+4HHLyVTCDJOHAjAQeusr2lwB2gHeTjQ7x2lDX/+J0UHPNLxYmAdBz35/GdN/T6G0bAWxy6nYoDvqmMCjZHBL+PBInbYX4vVfjjsA8JkJIAexgaWcOdvcDu4XUwoa0dpNa2MJDVwqm7aSijDGQwZIsIIL+MGkAEPOSAw5G2RIOMnEqkZZYhixWhnMyIaU/cGhNAhYlNqx+IWHpZQkUnIHoA8R5f4q1GgN67DOcD1+lh2mHO9kf4+Ag9fIzHJ/ze4cz9HJwJfM/FZjHUM3DiXhYO+2bgEKfBI2yJD/pk4AD3B3xTqAvpOPqgBIFJFTBzbkOQRjC2rQmZlQMM5Vbo2tkUC8bXRU9nR0ikNrDqOAvFbOZfpWrxJoNDDFnQhzDBaIlSpAgnWz1g7ghNQBYyKcSz6pE4X0zWUvLLqRslyCNz5TxHKfkMq7BqBAhR28XQ3ynKGwXvoM9rHLmTTOBvcdr/jR7wmTs5OB/Asdc3DedJyPl72ThBoGduZuOCXw4u+jH3Sci1+x/gzzKYXqpGP6+5zH8ZZDWdYWZlDZmtJQykUkhtTTCsux2WDraGi7McBsZ22HwuEtQ7vEouRqHoagUqdoLaShUKilgKWQZfZ2n1nWBqcTGnw0I+RamPhGymQBz15mm6EpFZasSwecik+DFokM0m6ku81QjYTeB72ODsY2n759YrHPFNpLdTcS0oB7fDSph3xXgS8QERL0sQl1iO9EwF3r0rQ/LbYiRlKfGWj9MLVMgqFvfmdfovJNI+lNC7JgxzR0htGP417JkKhnBu2oIkGMLGWoIRbjbwcHWG1FgGyw4jUckXim91CiuqrIzxm8q0eMHOL4Did+OFlhVAiwA2PW/YFaazHQ56ReWPLsfdmEoEsvQ+SVIimmUzka97y0YsOfcrhqEjFLojzNuTAezt779jaXmPm8F5LCkleMwPi0hU4zUXkcopL59tGss0OHZDlG8Rnv97+/RwwsyZbI4kkBG4Ya1ajAROefY19Dc4/tixFxKJBLZWEnw/sB76d7Rmmshx8fEL/eszc0pZ+soQwk7uCYepa9E6HHmsxsHHOhwPhr7en3mkxLmgSlwLU+tLYxC7wGd8bgjLZQR7hqBkFauGAsFxJZ9hFVaNgHN+bxjWqbgUyNC+m4zL9P7V++m4+SgTPk+y8Ty2HFFvNXgUq9B74yX78IRUJcOwCqxSpUF8fBryCip4ToucggLWeWMY2VrAwqkKvLmVJecC0ZlXkXQr6AWfY4K61gZYMMgRDnb2MLduhqJSFVI4QYXGFONWnA63otQ4/bgQ++5kYe+dArbfeRRidn+MzsBX5QhNo3PomKisMpbCApbFMgRG06IKERhZiCdx5Z9hFVaNgHuhRbgbUojbQVnwefZeD/6yXzKuBLzBzYdZuHklDKf2XkQ0O6vH0eIrKYYV8ysztxw79h+HpV1DKryMdV2OBi3bw4RCJ3Jd7lxH3yLXb9yIzxeJXVXa0lLe68tcaFohTM1MMbmrHMsG1oShVAabpqNQSTF7zwSOYk8fQZBxqeWIz65ASqESaXlK5HEqFKOuEMU89g8fGJUlFNFCakEG62FakY5awdJKvjN47Uu81QiITuJ0FasmuHL9d28pZDSOnn4Rr0YJZdS1VU/YW1gjwCcEcfHF2L7zHHp0HcQuz6yqxNGkjk4wMDfX57mBtR27vSb6FBgwfKT+trbYFKzT5SxVxfn5SE4r05e4TQfOwslMgsPDJajlZA5j8/rsBjV8TdW3Op+UX5iG+aYR9whECNE4+EGrZg/wQYd8akJuthaJGewc00oQyz4hIZNNFBujL/FWJyBeg7CocgQG5SM4PB9xSRS4FCpuCkWpTAkzSys09OiLkdPGwtnZQu/V/xjDW783NIDEqIoMA0mV9R89gXohpvKqxkaAUdArpfRwMYt0EYMiOa8cLjam8B4iR3N7agajKeKDBlH87HeZotFRU1xZAQgkgmU1gt1eJNvc19kKAixHMSsHs0b/3WHMO47IaQrODqwc4vtCCvLb919RBe48yYd/UAH8H+fhwdNMvEwoQAJzPjyqFLm5ZZDXqQOXgR5o138ATOVytGzdgUK2H7uPXcDWv/dh1779CHjwAClZfO2reGzasQ9HTl/Ql6g8kdMM2w8M0fQ8LV5SoF6wnIVwSHkg2tjUSnzTwBk+I80xoIU5JJwdLj37QN1RIT65SN8ZZjGcX6eVIoolMjy5FCEJRQiNz8er9CKk51TgHS2JZES+qUB8FvTdIYsIKhk2bAk+wyqsGgE+JOB2SBGeUnDes3QwApGayZwq5bR16hpMGN6mrVwhM7fGtbvhDGW+KVkXLSur1n+U/8vt0y2p9FwNQqJzEfSyGL4cWX0oUNfD8vE0XseZXYWOzRrh7GAppns01KfQvag0fbQUkrQc5rP4ElTcFarkuSKu7T09+75MiyKuIU/MD/lKzg0aEq1FPAenRA5mr5IK8Ca1GLmlX/E/RAJCCxH8WvTbVHjW+dikYkTFllJcdJg0dQ6M5RZoMWAC0guZXxka+FKBbzJaHj8vQFpqBTjE6b1dWKpARm4p8osVUHLx4tssMdnlspFJzmCDklSJpHR6tJg6wMWraOKbsEGdmmNFOwmGutfWp9SYqT/re4mYxDx9NL6hmr0vVOkJL6pQMrQrQNwkiMSUa5GXTxLYh7zNUTP/2ZPk8lyBhkJagvT3X3FX2OdxBh6GfcBj2pOwTASFJSPkRT7LG7B45RqWMFvkEFRMuhZBMaV4xhIVz+ZHeIgaBAVzurRcgdyCMuTlKJHPHM7IKUZOXgVLohI5uZW8LgTro3DxoEKtRKX+1g8wZ6IXulgawK2zI6uHBOaWNdkvUNzo8ix+rpgN9P/hiWFXWq5EGYl+x0qQw8/J/1CJIupENiMpPU/H8kxtYKoU85qK6xLfq3yJtxoBT18W4XlMiV4MY98oEJ9SithkBfKYDh8ogs8iXyEtR4uIeDYoqTpWCNH5cSGsaUKRFSoFikrKOHsz3AhU5N8HSrzo5CoYAcLLCo5pFXShilFVpixBma6SpFbd9X33LhU2ciM0amkHiaVMX1LTU7M/pgGHH4WKpbFK/cWdIkGiSC/qq/6c6EeKGVWiQRMzhNgLpyi4vgrFV6RAYhrrLGttWlYF29wSZGaXIz9fheyschQxr8QHFLIGVwqA9EIlUZXRE6LpUdJLHzi759H7ZeJDGbtKrlzL2FcK0HRdKUe9Iu7FYpWlldwLJAIIf33c/G4cgImJBKbmLK0SYzyOeKE/TzxVVYS/BGglDyrYeKWQvNRsNd7kKrH1Rhh++scXRx6m4g/vKCw8GYxpxwIx91QAusxa/BlWYdUIyEvLR/67PLxLzkUe62heBkfPtwXIy2Z4sbEQba+GSa4mcP10xoVoyazYxD1/vVeqMFWZ+PXFpi+BXLgAVMQQqeSx8JaC7ys8HPDiHcwd2AwZs48gAVMW78KZoBT8duUF1npHYugvxzBuywW0nrEe3ZfugvOUBWjw/UKYDZwGaU8vGA6YDMMOo2D0jSuM27nDsq8njDp0hMTe8jOswqoRUFSqRDG9paQHKxiiXA89yYVyhXHvSzl9KXDhdjACQhLx7HUGWa9kGKvgHxyHEj45mxPbu9IK/Hn4CiLfFcHvRSZO3IpnW50K76B32H4uGNN/PY6OXovg+esu1Bk0Fd1m/QLXKcvQ88e1qDFgEupOmQurtt+yDBrCyMwJEqeOMO45GpLGnSBt4gqbIRNg2L4nDF17QereG2Y9ukPi0giSmvVRz3MMvh03DXXdh8GiW0+Y9ewGybeNIW3RFKb1nD7DKqwaAf6R4fANDcHV0Ef4afsG/HLmIDZcPYEJ29eg68Kp6LpyGmpO7gbnqT0g92yJ+rN6o9mCQZCP+BZ153SDxbgWMB3RCDLPepANdIZsOCe8AaaQDjKDdLgZJN9xKpxoAel0S0hGG0H6g4zHzPUxRjD83hiGs3h9jhOcR9WHhBFgaMlqUNsSTVb0gONCe9SYZ40mvzaC1U/mcFxqB9sFFjCd5wDrKfawmWCL2guaoOa8+qj9fW0Yj20I86mtYDjcAfLhjpAPtP8Mq7BqBJh0kkPW2hRGzbiwZlxUEyNIGkohaUprx+PORjDoZwxJX14bItPvDboZQjKUHd8g7kdIYTiRz5tMm8i2eIYxZLOMIJsng+l8I1guk8FqtTFsVsvhsLIGHNc4otavtVBjFY9XOcDpN0fYrZehw9LGsKhnAYmco7OZIeqMrQm7v8xguk4CwxUSmGyQQL6JttkIFuvtUHO5HawXm0O2zAxmK81RY5kV7FbIYb1SCptlEjiuNoTTcuPPsAqrRoDnz8vgtWA1hixeioFLFqDfgh8xZOkSDFm2BMMWLYLHT7PR54dJ6Pb9aHQYOxidxw+B67jBaDWmK74Z3wJ1hzaGo0d92Pd3hFXvGrDp7wzLXs4w6WYHIw46UncS242e70lSPIxg1FMKox487mME4z4krD/NSwrzQVLU7sBuUG4JQ5N6MLSvRY8yisbL4DjPGfazHWE4zgTGk0nKDBPYTJGhxjQTWMw3h+FsI8inG8FsphlkMwzhsNAclnNNYD7L4jOswqoR0HPGDPSZPRt9f/gJg2ctwaDZCzFk7iIM+anKhi9cglFLVmPk4lUYuXQFvJauxuiVv2AU96OW/YLRy9fx8TqMX/M7Jq3/E1M3/IVJ6zbj+3UbMWXDJkz9/Q+MWfMrvJYvwYhV8zB86RwMXzyX5M7GdwtmYOBP32Pg3NEYOmcUhkwZyjRghHEylJrI0WfRz7Dp2AVD5i9A1ymT4NilJRxcG8Kuhwvk7k6Qdq4BaWtzSNtYwaS1FWRtLSFtxfQT0dxGDqP2XyGCruOnouMY2viJ6DR+PLpMmgz3yVPQ6/vp8PjhRwyYMw+9Z81Bv9lzGQ0LMGzxMnguXo7hy0nGipUYSRN7YSOWLqUtJymrMXzJMgxasBD9+NoBc8Tr56HnD3PRaxb3c36E25QZcJ08DZ0mUhSnz0aPKTP5vJ/RevBouI2ZixVn/OAx5ie06joCGw/fQK8JdNLcWRTQyej/wwz0pvWa9wN6zZ6OvjO41uncz+K6ZzBap0yA+5Tx6DZ1wmdYhVUjoM248WjpNQYtxo9C6yle6DRlIrpMng73cTSvGeg8Yho6jJyCzmOmoeOoqWg3YjI6jZ6ODiMmoNmgwWg5ZBiaDxqGbzyGoFHfgWjQpy8aD/DANwPFNU+08RyN1kOHo6XnSLQYNg7NPcfi26H8PM8JaDVyAtpRwZuP/QH1hoyD25wV6LZ4C9zWHof9qBUwMrXG8Ekrsf30QzRjqWviMQZNh4yCK9fVafQPaO01De3G/0DHzUKXsbPgOmEO2o+bidZcZ9vRvDZmxmdYhVUjwLpHQzTwbI/GY7qjvlcPuAx25/TXAw7du8GukyvsO7rCwa07bNp3Rm33nnDo2h01O7vResC5uwdcenyHOt1pPTxQv88wEuCJBqzD9XsPReN+I2hj0LDvaDTsNwqNvxsBlz5D0IxENBs2lgRMQsvh49Fs4Ei0GupF0oYxKmbDvt9YuIwkqB9XYeDqbVh66i523IrEtBX74TV9LRp380CrwV7692hJEr8dPIpEj0Pr4RPQcsR4tOB7is9qMMDzM6zCqhEgbS+FmaspzLpaw9jVDhbdnWDbrwns+jTlQprDpnczOHl0hPN3HVCzf2s49G2DWtzb924PK7fOsO/RBTV6dYVd9y6w7NoRNXp2RR2Pnqjdj2T16YkaPXrBzr0Parj3hUvffnDk43r9+8O5d2+4cO/CiGnNSGo3cABauXdBz0H90b67O9r3648OP85H95VrMXrrEUzeeBzXgzJw9NQzbD12Cs15vfGA/mjgMRAuA/qi4YABBEwnDBiIht95oCHP1+s/8DOswqoRYNLGlI2DBMZtWfZaSSBzk0HWk8ram6R42kDazxJmfWtA4m4Oq++cYD6ANXiQE8vUN7DzrA9HryZwGv0NrznDZpAL6o5rjppD68B+WH3YDW4EWw9eG0gi+7SEo7sb6vVlBLl3hq1rezh064Sa3bvCidFSq4Mb870jbCxkqGdtggY2Fujcpjtad/agGK/H2lP3MP23o5i75giWrd0Nu4ad0LTPCNRl1DXx8GL0eaJOr2Go23s4955w6e0JZz7+Em/1CGhsAqOG7AOam8CwJes6STBiRBi5yWHsLufi7WE+kAR0NYFpP1tIurAXcDeFJc+b9ZDDpCfLUm9zPsca8gGWkPUz5fOMYdKPfcAAOc0cph7WqDmqDgmpD5vv6sLGQxzXhS0Js/mOJY/KbtKZ6u7aBA5tm0Ben6W0bm3UcrJFLQd7NG/ZDG3at0fD5s1h5mALo0a2jKpvWQ3awr5nu6qI69sV9t06wNqtDZz6dEetHl1Ri2n8Jd5qBEiamELeypbNEJuQVnIYtiA4N3q5qyNM29pA1skaFn0cYMwUMXGzJjFWepN1ZunpwNe0ZJPUmqWrrQQGbSSQkiDjrlKSxzrf3Rjy/oycQdaQ9GKj5C4lQaz17AMkPWQw628JU5pZdzNY9LSBubs95N2dYeZWF6auLjBqZwnr9gT7rTmMaxnChms1/8aEPQad0o+dn7stTNxrwKqvC+wGNGYv0php2giGrW1h2dmFVv8zrMKqEfBvM0HAv/5PZ//Nfzy9RRDw6c/nxZ+U/7cn/f9oH/98vp7s/wBDAIy+3ttO9gAAAABJRU5ErkJggg=="
                  />
                  <input type="hidden" placeholder="returnURL" name="returnURL" value="https://trade.nirmanbroking.com:3000/interactive/testapi" />

                  <input type="hidden" placeholder="loginText" name="loginText" value="Login To SYMPHONY" />

                  <input type="hidden" placeholder="postBackUrl" name="postBackUrl" value="https://prod-api.stockants.com/api/auth/v1/nirman_api" />

                  <button class="signup-btn btn-secondary-theme-filled" type="submit">Login</button>
                </form>
              </div>
              <img v-else :src="profile_pic" class="profile-pic" height="30" width="30" slot="reference" @click="goToDashboard()" />
            </div>
            <button class="signup-btn btn-secondary-theme-filled" @click="login('login')" style="margin: 0; margin-left: 5px" v-if="!userProfile && websiteUserType && websiteUserType.userType != 'broker'">Login</button>
          </div>
        </div>
      </div>
      <div class="list">
        <div class="flex-space-between list-1">
          <div class="flex">
            <!-- @click="$router.push('/retail-investors')" -->
            <img src="../../assets/images/logo/logo1.png" class="cursor-pointer navbar-logo" />
            <img v-if="currentEnvironment.logo" :style="[currentEnvironment.width ? { width: currentEnvironment.width } : {}]" :src="currentEnvironment.logo" class="cursor-pointer navbar-logo broker-logo" />
          </div>
          <div class="flex" style="margin-left: 40px">
            <div
              class="navbar-menu"
              @click="$router.push('/retail-investors')"
              :style="{
                color: $route.path == '/retail-investors' ? '#d60918' : '',
              }"
              v-if="$route.path == '/' || $route.path == '/options/expert-view' || $route.path == '/markets-overview'"
            >
              Home
            </div>

            <div
              class="navbar-menu"
              @click="$router.push('/markets-overview')"
              v-if="$route.name != 'BrokerSideExpertLandingpage' && !currentUrl.includes('zebuetrade.stockants.com') && !currentUrl.includes('aliceblue.stockants.com')"
              :style="{
                color: $route.path == '/markets-overview' ? '#d60918' : '',
              }"
            >
              Markets
            </div>
            <div
              class="navbar-menu"
              @click="$router.push('/')"
              v-if="!($route.name == 'BrokerSideExpertLandingpage') && !userProfile"
              :style="{
                color: $route.path == '/' || $route.path == '/options/expert-view' ? '#d60918' : '',
              }"
            >
              Expert View
            </div>

            <div class="navbar-menu" v-on:click="selectedSegment == 'equity' ? goToLink('/data-categorisation') : goToLink('/expert-past-strategy-options')" v-if="userProfile">Expert View</div>
            <el-button v-if="userProfile && $route.name != 'BrokerSideExpertLandingpage' && userProfile.navigation && userProfile.utm_source != 'Fyers' && userProfile.utm_source != 'Zerodha' && userProfile.profession != 'Dealer' && websiteUserType.userType == 'broker' && currentEnvironment.isTradeAvailable" class="btn-secondary-theme-filled publish-btn left-margin-10" size="mini" v-on:click="goToTradePage()">TRADE</el-button>
          </div>
        </div>
        <div class="flex-space-between list-2">

          <!-- <div class="right-margin-15" v-if="$route.path == '/' || $route.path == '/options/expert-view'">
            <div class="market-type-dropdown">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  <div class="menu-links active-menu-link">
                    <span slot="reference" class="cursor-pointer uppercase" style="font-size: 11px">{{ selectedSegment }}</span>
                    <i class="el-icon-arrow-down el-icon--right cursor-pointer"></i>
                  </div>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    class="menu-bar-items"
                    v-on:click.native="selectMarketType('equity')"
                    :class="{
                      'active-menu-link': selectedSegment == 'equity',
                    }"
                  >
                    Equity
                  </el-dropdown-item>
                  <el-dropdown-item
                    class="menu-bar-items"
                    v-on:click.native="selectMarketType('options')"
                    :class="{
                      'active-menu-link': selectedSegment == 'options',
                    }"
                  >
                    Options
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div> -->

          <div class="flex" v-if="currentEnvironment.loginModule != 'BlinkX'">
            <el-button class="btn-theme-filled" size="mini" v-if="currentUrl.includes('nuvama.stockants.com')" @click="goToDematLink('https://onboarding.nuvamawealth.com/?utm_source=nuvamawealth.com&utm_term=Web_Account_Opening&utm_campaign=openaccount&utm_medium=website')">Open Demat account</el-button>

            <button v-if="!userProfile && paytmSource != 'app' && currentEnvironment && currentEnvironment.utm_source != 'Nirman'" class="signup-btn btn-secondary-theme-filled" @click="currentUrl.includes('paytmmoney.stockants.com') || currentUrl.includes('nuvama.stockants.com') || currentUrl.includes('zebuetrade.stockants.com') || currentUrl.includes('hdfcsky.stockants.com') || currentUrl.includes('rupeezy.stockants.com') || currentUrl.includes('fyers.stockants.com') || currentUrl.includes('enrichmoney.stockants.com') || currentUrl.includes('bajajbroking.stockants.com') || currentUrl.includes('almondz.stockants.com') || currentUrl.includes('almondztrade.stockants.com') || currentUrl.includes('aliceblue.stockants.com') || currentUrl.includes('shareindia-trade.stockants.com') ? getRedirectURLForBroker() : login('signUp')">
              {{ websiteUserType.userType == 'broker' ? 'Login' : 'Sign Up' }}
            </button>
            <div v-else-if="!userProfile && currentEnvironment && currentEnvironment.utm_source == 'Nirman'">
              <form method="POST" target="_self" contentType="application/x-www-form-urlencoded" action="https://trade.nirmanbroking.com:3000/interactive/thirdparty" dataType="application/x-www-form-urlencoded">
                <img
                  style="visibility: hidden; width: 0px"
                  src="data:image/png;base64,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"
                />
                <input type="hidden" placeholder="returnURL" name="returnURL" value="https://trade.nirmanbroking.com:3000/interactive/testapi" />

                <input type="hidden" placeholder="loginText" name="loginText" value="Login To SYMPHONY" />

                <input type="hidden" placeholder="postBackUrl" name="postBackUrl" value="https://prod-api.stockants.com/api/auth/v1/nirman_api" />

                <button class="signup-btn btn-secondary-theme-filled" type="submit">Login</button>
              </form>
            </div>
            <img v-else :src="profile_pic" class="profile-pic" height="30" width="30" slot="reference" @click="goToDashboard()" />
          </div>

          <button class="signup-btn btn-secondary-theme-filled" @click="login('login')" style="margin: 0; margin-left: 5px" v-if="!userProfile && websiteUserType && websiteUserType.userType != 'broker'">Login</button>
        </div>
      </div>
    </div>

    <div id="mobileNav">
      <div class="sideBar">
        <div class="sideBar-logo-section">
          <img src="../../assets/images/logo/logo1.png" class="stockants-logo" />
        </div>

        <div class="profile-section flex-space-between" v-if="userProfile">
          <div class="flex">
            <div class="relative">
              <img :src="profile_pic" v-if="userProfile.picture" class="sideNav-profile-pic" />

              <img src="../../assets/images/navBar/avatar.jpg" v-else class="sideNav-profile-pic" />
            </div>

            <div class="profile-details-section left-margin-10" @click="userProfile.source != 'Angelone' && websiteUserType.userSubType != 'brokerWithoutPlans' ? goToLink('/profile-update') : ''">
              <div class="font-09rem font-weight-600 capitalize" v-if="userProfile.full_name">
                {{ userProfile.full_name }}
                <span>
                  <el-tooltip v-if="userProfile.mark_as_verified_user" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
                    <img class="info-Logo cursor-pointer" src="../../assets/images/verify.svg" style="width: 16px; position: relative; top: 3px" alt />
                  </el-tooltip>
                </span>
              </div>

              <div class="font-09rem font-weight-600 top-margin-10" v-else-if="!userProfile.full_name && userProfile.email">
                {{ userProfile.email }}
              </div>

              <div class="input-label-gray top-margin-5">
                {{ userProfile.profession }}
              </div>
            </div>
          </div>

          <div class="cursor-pointer" @click="userProfile.source != 'Angelone' && websiteUserType.userSubType != 'brokerWithoutPlans' ? goToLink('/profile-update') : ''">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="">
          <div v-if="websiteUserType.userType != 'broker' && !userProfile" class="">
            <div @click="$router.push({ name: 'RetailSideLandingPage' })" :class="$route.name.includes('RetailSide') || (showPlan == 'retail' && $route.name.includes('NewPricing')) || (showPlan == 'retail' && $route.name.includes('Performers')) || (showPlan == 'retail' && $route.name.includes('ExpertCover')) || $route.path == '/stockants-compliance' ? 'active-invester-btn' : 'invester-btn'">Retail</div>
            <div class="invester-btn" @click="$router.push({ name: 'AdvisorSideExpertLanding' })" :class="$route.name.includes('SideExpert') || (showPlan == 'expert' && $route.name.includes('NewPricing')) || (showPlan == 'expert' && $route.name.includes('Performers')) || (showPlan == 'expert' && $route.name.includes('ExpertCover')) ? 'active-invester-btn' : 'invester-btn'">Experts</div>
          </div>
          <div v-if="!($route.name == 'BrokerSideExpertLandingpage') && websiteUserType.userSubType != 'brokerWithoutPlans' && userProfile && userProfile.profession != 'Dealer' && currentEnvironment.loginModule != 'BlinkX'" class="menu-item flex-space-between" :class="{ 'active-menu-item': active_menu_item == '/pricing' }">
            <div @click="goToLink('/pricing')">Plans</div>

            <div v-if="userProfile">
              <div class="go-premium-btn" v-if="Object.keys(getSubscribedPlanDetails).length && getSubscribedPlanDetails.plan != 'Premium' && getSubscribedPlanDetails.plan != 'Pro'" @click="checkSubscribePlanDetails()">Go Premium</div>

              <div class="go-premium-btn" v-else @click="goToLink('/my-account')">Plan details</div>
            </div>
          </div>

          <div
            class="menu-item"
            @click="$router.push('/markets-overview')"
            :class="{
              'active-menu-item': active_menu_item == '/markets-overview',
            }"
            v-if="$route.name != 'BrokerSideExpertLandingpage' && !currentUrl.includes('zebuetrade.stockants.com') && !currentUrl.includes('aliceblue.stockants.com')"
          >
            Markets
          </div>

          <div
            class="menu-item"
            v-if="currentUrl.includes('aliceblue.stockants.com') || currentUrl.includes('nuvama.stockants.com')"
            :class="{
              'active-menu-item': active_menu_item == '/broker-disclaimer',
            }"
            @click="goToLink('/broker-disclaimer')"
          >
            Broker Disclaimer
          </div>
          <div
            class="menu-item"
            v-if="currentUrl.includes('hensex.stockants.com')"
            :class="{
              'active-menu-item': active_menu_item == '/broker-disclaimer',
            }"
          >
            <a href="https://www.hensexsecurities.com/research-analyst-disclosures-disclaimers/" target="_blank" style="text-decoration: none; color: #606266">Broker Disclaimer</a>
          </div>

          <div class="menu-item" v-if="currentUrl.includes('gcl.stockants.com')">
            <a href="https://prod-api.stockants.com/Media/important_doc/Stockantscompliancenewgcl.pdf" download="GCL Disclaimer.pdf" style="text-decoration: none; color: #2d2e8d" target="_blank">Broker Disclaimer</a>
          </div>

          <div
            class="menu-item"
            :class="{
              'active-menu-item': active_menu_item == '/stockants-compliance',
            }"
            @click="goToLink('/stockants-compliance')"
          >
            StockAnts Compliance
          </div>

          <div
            class="menu-item"
            :class="{
              'active-menu-item': active_menu_item == '/retail-side/faq',
            }"
            @click="goToLink('/retail-side/faq')"
            style="border-bottom: 1px solid #e4e6ec; margin-bottom: 50px"
            v-if="this.userProfile && this.userProfile.profession == 'Retail Investor'"
          >
            FAQs
          </div>

          <div
            class="menu-item"
            :class="{
              'active-menu-item': active_menu_item == '/advisors/expert-side/faq',
            }"
            @click="goToLink('/advisors/expert-side/faq')"
            style="border-bottom: 1px solid #e4e6ec"
            v-else
          >
            FAQs
          </div>


          <div
            class="menu-item"
            :class="{
              'active-menu-item': active_menu_item == '/business-partners',
            }"
            @click="$router.push({ name: 'BecomeBusinessPartners' })"
            style="border-bottom: 1px solid #e4e6ec; margin-bottom: 50px"
          >
            Become Business partners
          </div>
        </div>
      </div>
      <div>
        <div class="bottom-section" style="width: 260px; text-align: left">
          <div v-if="!userProfile" class="flex-space-between">
            <div class="menu-item" @click="currentUrl.includes('paytmmoney.stockants.com') || currentUrl.includes('nuvama.stockants.com') || currentUrl.includes('zebuetrade.stockants.com') || currentUrl.includes('hdfcsky.stockants.com') || currentUrl.includes('rupeezy.stockants.com') || currentUrl.includes('fyers.stockants.com') || currentUrl.includes('enrichmoney.stockants.com') || currentUrl.includes('bajajbroking.stockants.com') || currentUrl.includes('almondz.stockants.com') || currentUrl.includes('almondztrade.stockants.com') || currentUrl.includes('aliceblue.stockants.com') || currentUrl.includes('shareindia-trade.stockants.com') ? getRedirectURLForBroker() : login('signUp')" v-if="!userProfile && paytmSource != 'app' && currentEnvironment && currentEnvironment.utm_source != 'Nirman' && currentEnvironment.loginModule != 'BlinkX'" style="width: 50%">
              {{ websiteUserType.userType == 'broker' ? 'Login' : 'Sign Up' }}
            </div>

            <div v-else-if="!userProfile && currentEnvironment && currentEnvironment.utm_source == 'Nirman'">
              <form method="POST" target="_self" contentType="application/x-www-form-urlencoded" action="https://trade.nirmanbroking.com:3000/interactive/thirdparty" dataType="application/x-www-form-urlencoded">
                <img
                  style="visibility: hidden; width: 0px"
                  src="data:image/png;base64,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"
                />
                <input type="hidden" placeholder="returnURL" name="returnURL" value="https://trade.nirmanbroking.com:3000/interactive/testapi" />

                <input type="hidden" placeholder="loginText" name="loginText" value="Login To SYMPHONY" />

                <input type="hidden" placeholder="postBackUrl" name="postBackUrl" value="https://prod-api.stockants.com/api/auth/v1/nirman_api" />

                <div class="menu-item" type="submit">Login</div>
              </form>
            </div>

            <div v-if="!userProfile && websiteUserType && websiteUserType.userType != 'broker'" class="menu-item text-right" style="width: 50%" @click="login('login')">Login</div>
          </div>
          <div class="menu-item" v-else-if="userProfile && paytmSource != 'app' && !currentEnvironment.byPassLogin && currentEnvironment.loginModule != 'BlinkX' && !currentUrl.includes('almondz.stockants.com') && !currentUrl.includes('almondztrade.stockants.com')" @click="logOut()">Logout</div>
        </div>
      </div>
    </div>

    <div class="footer-nav">
      <div class="footer-inner">
        <div class="sections cursor-pointer" v-if="currentEnvironment && currentEnvironment.byPassLogin">
          <i class="el-icon-back" @click="backToPrevious()" style="font-size: 21px"></i>
          <br />
          <p class="label menu-links">Back</p>
        </div>
        <div v-else>&nbsp;</div>
        <div v-if="userProfile && $route.name != 'BrokerSideExpertLandingpage' && userProfile.navigation && userProfile.utm_source != 'Fyers' && userProfile.utm_source != 'Zerodha' && userProfile.profession != 'Dealer' && websiteUserType.userType == 'broker' && currentEnvironment.isTradeAvailable" class="sections" v-on:click="goToTradePage()">
          <img src="../../assets/images/Trade (Active).svg" alt="" v-if="active_menu_item == '/trading'" />
          <img src="../../assets/images/Trade.svg" alt="" v-else />
          <p class="label" :style="[active_menu_item == '/trading' ? { color: 'red' } : {}]">Trade</p>
        </div>

        <div class="sections" v-on:click="goToLink('/')" v-if="!userProfile">
          <img src="../../assets/images/comment-altActive.svg" alt="" v-if="active_menu_item == '/' || active_menu_item == '/options/expert-view'" />
          <img src="../../assets/images/comment-alt.svg" alt="" v-else />
          <p class="label font-weight-500" :style="[active_menu_item == '/' || active_menu_item == '/options/expert-view' ? { color: 'red' } : {}]">Expert View</p>
        </div>

        <div class="sections" v-on:click="selectedSegment == 'equity' ? goToLink('/expert-view-lite') : goToLink('/expert-past-strategy-options')" v-if="userProfile">
          <img src="../../assets/images/comment-alt.svg" alt="" />
          <p class="label font-weight-500">Expert View</p>
        </div>

        <!-- <el-dropdown class="active-menu-link font-weight-500">
          <span class="el-dropdown-link capitalize" :style="[active_menu_item == '/' || active_menu_item == '/options/expert-view' ? { color: 'red' } : {}]" style="font-size: 14px; font-weight: 600">
            {{ selectedSegment }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-on:click.native="selectMarketType('equity')"
              :class="{
                'active-menu-link': selectedSegment == 'equity',
              }"
            >
              Equity
            </el-dropdown-item>
            <el-dropdown-item
              v-on:click.native="selectMarketType('options')"
              :class="{
                'active-menu-link': selectedSegment == 'options',
              }"
            >
              Options
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { serverAddr, serverHostName } from '../../networkConfig';
import { EventBus } from '../../eventBus';
import { loginNetworkCallBack } from '../../mixins/login.NetworkCallback';
import { HelperNetworkCallBack } from '../../mixins/Helper';

export default {
  name: 'Retailnavbar',
  mixins: [loginNetworkCallBack, HelperNetworkCallBack],
  data() {
    return {
      moment: moment,
      showNavbar: false,
      twitter_link: 'https://twitter.com/StockAnts',
      fb_link: 'https://www.facebook.com/StockAnts/?view_public_for=186471548792050',
      linkedIn_link: 'https://www.linkedin.com/company/stockants/about/?viewAsMember=true',
      userProfile: null,
      profile_pic: require('../../assets/images/navBar/avatar.jpg'),
      offerImage: require('../../assets/images/OfferBanner.svg'),
      userType: '',
      showPlan: '',
      currentUrl: '',
      selectedSegment: localStorage.getItem('market_type') ? localStorage.getItem('market_type') : 'equity',
      websiteUserType: {},
      currentEnvironment: {},
      paytmSource: '',
      brokers_list: [],
      redirectUrlForRmoney: '',
      redirectUrlForGcl: '',
      active_menu_item: '',
      windowWidth: window.innerWidth,
      isLandingPage: false,
      upstoxAccessToken: '',
      redirectUrl: 'https://uat-upstox.stockants.com/',
      orderData: '',
    };
  },
  beforeCreate() {},
  watch: {
    // Watch for changes if needed
    websiteUserType: {
      handler(newVal) {
        localStorage.setItem('websiteUserType', JSON.stringify(newVal));
      },
      deep: true,
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.checkLandingPage();
  },

  mounted() {
    this.selectUserType();

    const storedUserType = JSON.parse(localStorage.getItem('websiteUserType'));
    if (storedUserType) {
      this.websiteUserType = storedUserType;
    }

    this.active_menu_item = this.$route.path;

    if (this.$route.path == '/options/expert-view' || this.$route.path == '/expert-past-strategy-options') {
      this.selectedSegment = 'options';
    } else if (this.$route.path == '/' || this.$route.path == '/expert-view-lite') {
      this.selectedSegment = 'equity';
    }
    // after logout save currentUrl
    if (!localStorage.getItem('currentUrl')) {
      this.selectUserType();
    }

    if (localStorage.getItem('paytmSource')) {
      this.paytmSource = 'app';
    }

    this.currentUrl = localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href;

    let body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';

    if (localStorage.getItem('profile')) {
      this.userProfile = JSON.parse(localStorage.getItem('profile'));
      if (this.userProfile.picture.length) {
        this.profile_pic = serverHostName + this.userProfile.picture;
      }
    }

    // this.userProfile.utm_source = 'Basan'

    if (localStorage.getItem('roles')) {
      var role = JSON.parse(localStorage.getItem('roles'));
      this.userType = role[0];
    } else if (localStorage.getItem('UserType')) {
      this.userType = localStorage.getItem('UserType');
    }

    if (this.userType == 'Financial Advisor' || this.userType == 'Non Financial Advisor' || this.userType == 'Market Expert' || this.userType == 'Broker' || this.userType == 'Analyst' || this.userType == 'ADVISOR' || this.userType == 'BROKER') {
      this.showPlan = 'expert';
    } else {
      this.showPlan = 'retail';
    }

    // get currentEnvironment details
    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
    }

    // Check queryparams to Almondz login
    if (this.$route.query.mobile && this.currentUrl.includes('almondz.stockants.com')) {
      let mobile_number = this.$route.query.mobile ? this.$route.query.mobile : '';

      if (!localStorage.getItem('profile')) {
        this.almondzAuth();
      } else {
        this.$router.push({ path: '/experts-past-recommendations' });
      }
    }

    // Check queryparams to login broker
    if (this.$route.query.tokenId || this.$route.query.auth_token || this.$route.query.encrTkn || this.$route.query.RequestToken || this.$route.query.jwtToken || this.$route.query.request_token || this.$route.query.auth_code || this.$route.query.auth || this.$route.query.access_token || this.$route.query.clientid || this.$route.query.requestToken || this.$route.query.code || this.$route.query.sid || this.$route.query.client_id || this.$route.query.authCode || this.$route.query.susertoken || this.$route.query.session || this.$route.query.userId || this.$route.query.sRestSession || this.$route.query.client_code) {
      let token = this.$route.query.tokenId
        ? this.$route.query.tokenId
        : this.$route.query.auth_token
        ? this.$route.query.auth_token
        : this.$route.query.encrTkn
        ? this.$route.query.encrTkn
        : this.$route.query.RequestToken
        ? this.$route.query.RequestToken
        : this.$route.query.jwtToken
        ? this.$route.query.jwtToken
        : this.$route.query.request_token
        ? this.$route.query.request_token
        : this.$route.query.auth_code
        ? this.$route.query.auth_code
        : this.$route.query.auth
        ? this.$route.query.auth
        : this.$route.query.access_token
        ? this.$route.query.access_token
        : this.$route.query.clientid
        ? this.$route.query.clientid
        : this.$route.query.requestToken
        ? this.$route.query.requestToken
        : this.$route.query.code
        ? this.$route.query.code
        : this.$route.query.sid
        ? this.$route.query.sid
        : this.$route.query.client_id
        ? this.$route.query.client_id
        : this.$route.query.authCode
        ? this.$route.query.authCode
        : this.$route.query.sRestSession
        ? this.$route.query.sRestSession
        : this.$route.query.susertoken
        ? this.$route.query.susertoken
        : this.$route.query.session
        ? this.$route.query.session
        : this.$route.query.userId
        ? this.$route.query.userId
        : this.$route.query.client_code
        ? this.$route.query.client_code
        : '';

      // if (!localStorage.getItem('profile')) {
      this.sendTokenToServer(token);
      // } else {
      //   this.$router.push({ path: '/experts-past-recommendations' });
      // }
    }
    // localStorage.getItem("selected_broker") == 43 ||
    if (localStorage.getItem('selected_broker') && (localStorage.getItem('selected_broker') == 21 || localStorage.getItem('selected_broker') == 22)) {
      this.gerBrokersList();
    }

    if (this.$route.query.ucc) {
      localStorage.setItem('paytmSource', 'app');
    }
    // Update window width when the component is mounted
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    submitForm() {
      // Perform any necessary validation or data manipulation here
      // Then submit the form
      document.getElementById('uplink-place').submit();
    },
    backToPrevious() {
      window.history.back();
    },
    selectMarketType(market_type) {
      this.selectedSegment = market_type;
      if (this.userProfile) {
        if (this.selectedSegment == 'options') {
          this.$router.push('/expert-past-strategy-options');
        } else if (this.selectedSegment == 'equity') {
          this.$router.push('/data-categorisation');
        }
      } else {
        if (this.selectedSegment == 'options') {
          this.$router.push('/options/expert-view');
        } else if (this.selectedSegment == 'equity') {
          this.$router.push('/');
        }
      }
    },
    goToPaytmMoney() {
      window.dispatchEvent(new Event('goBackToPaytmMoney'));
    },
    // stored in store boolean value---to open demo dialog
    openDemoDialog() {
      this.$store.commit('commitDialogVisibility', true);
      this.closeSideBarForMobile();
      this.toggleSideMenu = '';
    },
    goToDematLink(link) {
      window.open(link, '_blank');
    },
    gerBrokersList() {
      serverAddr
        .post('/auth/v1/broker/list', {
          // page_source: this.UserType,
        })
        .then((response) => {
          if (response.data.status && response.data.data.length) {
            this.brokers_list = response.data.data;

            var broker_id = localStorage.getItem('selected_broker');
            var brokerObj = this.brokers_list.filter((e) => {
              return e.id == broker_id;
            })[0];
            this.redirectUrlForRmoney = brokerObj.redirect_url;
            // this.redirectUrlForGcl = brokerObj.redirect_url;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRedirectUrlForBasan() {
      var redirectUrl;
      if (this.currentUrl.includes('https://uat-basan.stockants.com')) {
        redirectUrl = 'https://uat-basan.stockants.com/';
      } else if (this.currentUrl.includes('https://basan.stockants.com')) {
        redirectUrl = 'https://basan.stockants.com/';
      } else if (this.currentUrl.includes('basan.stockants.com')) {
        redirectUrl = 'http://localhost:8080/';
      }
      return redirectUrl;
    },

    async almondzAuth() {
      let broker_id;
      broker_id = Number(localStorage.getItem('selected_broker'));

      await serverAddr
        .post(`/auth/v1/non_demat_auth_for_broker`, {
          url: window.location.href,
          broker_id: Number(broker_id),
        })
        .then((response) => {
          this.loginUserNetworkCallBack(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async sendTokenToServer(token_id) {
      this.is_brokers_list_loading = true; //enabled loader
      var redirectUrl = '';

      let broker_id;
      broker_id = Number(localStorage.getItem('selected_broker'));

      if (this.currentEnvironment && this.currentEnvironment.utm_source == 'Basan') {
        redirectUrl = this.getRedirectUrlForBasan();
      } else if (this.currentEnvironment.utm_source == 'Choice' || this.currentEnvironment.utm_source == 'Nirman' || this.currentEnvironment.utm_source == 'Aliceblue' || this.currentEnvironment.utm_source == 'Nuvama' || this.currentEnvironment.utm_source == 'Rmoney' || this.currentEnvironment.utm_source == 'Zebu' || this.currentEnvironment.utm_source == 'GCL' || this.currentEnvironment.utm_source == 'HDFC Sky' || this.currentEnvironment.utm_source == 'Rupeezy' || this.currentEnvironment.utm_source == 'Enrich Money' || this.currentEnvironment.utm_source == 'Upstox' || this.currentEnvironment.utm_source == 'Fyers' || this.currentEnvironment.utm_source == 'Bajaj Broking' || this.currentEnvironment.utm_source == 'Almondz Trade' || this.currentEnvironment.utm_source == 'Share India Trade' || broker_id == 6 || broker_id == 24) {
        redirectUrl = window.location.href;
      } else {
        redirectUrl = `?success=true&requestToken=${token_id}&state=login`;
      }

      // var nvm_msg_token = localStorage.getItem("nvm_msg_token")
      //   ? localStorage.getItem("nvm_msg_token")
      //   : "";
      if (broker_id) {
        await serverAddr
          .post(`auth/v1/level_two_auth_for_broker`, {
            broker_id: Number(broker_id),
            token_id: token_id,
            url: redirectUrl,
            profession: 'RETAIL_INVESTOR',
          })
          .then((response) => {
            this.loginUserNetworkCallBack(response);
            // if (
            //   this.currentEnvironment.utm_source == "Nuvama" &&
            //   localStorage.getItem("nvm_msg_token")
            // ) {
            //   localStorage.removeItem("nvm_msg_token");
            // }
            this.is_brokers_list_loading = false; //disabled loader
          })
          .catch((error) => {
            console.log(error);
            this.is_brokers_list_loading = false; //disabled loader
          });
      }
    },

    goToLink(link) {
      if (link) {
        this.$router.push(link);
      }
    },

    logOut() {
      serverAddr
        .post('/auth/v1/sign_out', {
          refresh_token: localStorage.getItem('refresh_token'),
        })
        .then(this.logoutUserNetworkCallBack)
        .catch(function (error) {
          console.log(error);

          localStorage.clear();
          // to set state to it's initial state and clear vue store
          this.$store.commit('resetAllState');
          let body = document.getElementsByTagName('body')[0];
          body.style.overflow = 'auto';
        });
    },

    goToDashboard() {
      // if (this.userProfile && websiteUserType.userType == "broker") {
      //   this.$router.push({ path: "/experts-past-recommendations" });
      // } else {
      this.selectedSegment == 'equity' ? this.$router.push('/experts-past-recommendations') : this.$router.push('/expert-past-strategy-options');
      // }
    },

    login(action) {
      if (this.currentEnvironment.utm_source == 'Basan') {
        this.basanLogin();
      } else if (this.currentEnvironment.utm_source == 'Choice') {
        this.choiceLogin();
      } else if (this.currentEnvironment.byPassLogin) {
        this.$router.push({ path: '/auth-bypass' });
      } else {
        if (action == 'login') {
          this.$router.push({ path: '/login' });
        } else {
          this.$router.push({ name: 'login', params: { plan: 'register' } });
        }
      }
    },

    choiceLogin() {
      let oauth2Endpoint = '';
      let params = {};
      if (this.currentUrl.includes('https://uat-choice.stockants.com')) {
        // for staging
        oauth2Endpoint = 'https://devfinx.choiceindia.com/auth/login/';
        params = {
          redirectUrl: 'https://uat-choice.stockants.com',
        };
      } else if (this.currentUrl.includes('https://choice.stockants.com')) {
        // for production
        oauth2Endpoint = 'https://finx.choiceindia.com/auth/login/';
        params = {
          redirectUrl: 'https://choice.stockants.com',
        };
      }
      var form = document.createElement('form');
      form.setAttribute('method', 'GET');
      form.setAttribute('action', oauth2Endpoint);
      for (var p in params) {
        let input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', p);
        input.setAttribute('value', params[p]);
        form.appendChild(input);
      }
      document.body.appendChild(form);
      form.submit();
    },

    basanLogin() {
      let oauth2Endpoint = 'https://cash.basanonline.com/oauth2/auth';
      var form = document.createElement('form');
      form.setAttribute('method', 'GET');

      form.setAttribute('action', oauth2Endpoint);

      let params = {
        scope: 'orders holdings',
        state: 'orders holdings',
        redirect_uri: window.location.href,
        response_type: 'code',
        client_id: 'BASAN-STOCKANTS',
      };

      for (var p in params) {
        let input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', p);
        input.setAttribute('value', params[p]);
        form.appendChild(input);
      }
      document.body.appendChild(form);
      form.submit();
    },

    getRedirectURLForBroker() {
      var selected_broker;

      selected_broker = localStorage.getItem('selected_broker') ? Number(localStorage.getItem('selected_broker')) : '';
      if (selected_broker) {
        serverAddr
          .get(`auth/v1/level_one_auth_for_broker?broker_id=${selected_broker}`)
          .then((response) => {
            if (response.data.status) {
              // localStorage.setItem(
              //   "nvm_msg_token",
              //   response.data.data.msg_token
              // );
              window.location.href = response.data.data.redirect_url;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    toggleTopNav() {
      this.showNavbar = !this.showNavbar;
      var mobileNav = document.getElementById('mobileNav');
      if (this.showNavbar) {
        mobileNav.style.display = 'block';
        mobileNav.style.left = '0';
        document.getElementById('overlay').style.display = 'block';
        let body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'hidden';
      } else {
        mobileNav.style.left = '-360px';
        document.getElementById('overlay').style.display = 'none';
        let body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'auto';
      }
    },

    goToTradePage() {
      if (this.isTradeVisible()) {
        this.$router.push('/trading');
      } else {
        if (this.websiteUserType.userType != 'broker') {
          this.$store.commit('commitBrokerLoginDialogVisibility', true);
        } else {
          this.$store.commit('commitSubscribPlanDialogVisibility', true);
        }
      }
    },

    checkSubscribePlanDetails() {
      if (!Object.keys(this.getSubscribedPlanDetails).length || this.getSubscribedPlanDetails.plan == 'Lite') {
        localStorage.setItem('premiumPlanSubscriptionDialogVisible', true);

        this.$router.push({ path: '/pricing' });
        return;
      }
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    checkLandingPage() {
      // Check if the current route matches the landing page route
      if (this.$route.name === 'RetailSideLandingPage') {
        this.isLandingPage = true;
      }
    },

    navigateToRetail() {
      if (this.$route.path === '/stockants-compliance-experts') {
        this.$router.push({ path: '/stockants-compliance' });
      } else {
        this.$router.push({ name: 'RetailSideLandingPage' });
      }
    },
    navigateToExpert() {
      if (this.$route.path === '/stockants-compliance') {
        this.$router.push({ path: '/stockants-compliance-experts' });
      } else {
        this.$router.push({ name: 'AdvisorSideExpertLanding' });
      }
    },
  },
  computed: {
    //returns subscribed plan details from local storage
    getSubscribedPlanDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },
  },
  beforeDestroy() {
    EventBus.$off();
  },

  beforeCreate() {
    // check user login status
    if (window.localStorage.getItem('expire_in')) {
      let expires_in = window.localStorage.getItem('expire_in');
      const is_expired = new Date() > new Date(expires_in);
      if (is_expired) {
        localStorage.clear();
        if (window.location.href != '/') {
          this.$router.push({ path: '/' });
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../css/variable.scss';
@import '../../css/common.scss';

.retail-navbar {
  z-index: 2;

  .offer-img-outer {
    display: none;

    .offer-img {
      width: 480px;
    }
  }

  .sideNav-profile-pic-section {
    // 25255e
    height: 45px;
    min-width: 45px;
    // margin: 0 auto;
    border-radius: 100%;
    // border: 2px solid #df6052;
    background-color: #fff;
    padding: 2px;
    display: inline-block;
  }

  .sideNav-profile-pic {
    height: 45px;
    width: 45px;
    object-fit: cover;
    border-radius: 100%;
  }

  .sideNav-profile-name {
    color: #414550;
    font-size: 0.9rem;
    font-weight: 300;
    margin: 0px 0px 0 10px;
  }

  .stockants-logo {
    width: 180px;
    height: 100%;
  }

  .profile-section {
    padding: 0 15px;
    color: #111112;
    margin: 15px 0;
  }

  .sideBar-logo-section {
    padding: 10px 5px 0px 12px;
    font-size: 1.5rem;
    color: #fff;
    font-weight: 300;
    line-height: 30px;
    border-bottom: solid #414550;
    border-width: thin;
  }

  .sideBar-menu-section {
    margin: 15px 0;
    padding: 3px 0;
    // height: 450px;
    overflow: auto;
  }

  .menu-item {
    cursor: pointer;
    padding: 12px 20px 12px 20px;
    text-decoration: none;
    font-size: 0.8rem;
    color: #111112;
    transition: 0.3s;
    text-decoration: none;
    font-weight: 500;
    border-top: 1px solid #e4e6ec;
  }

  .go-premium-btn {
    color: #fff;
    background: $secondary-theme-color;
    padding: 5px 8px;
    font-size: 0.6rem;
    border-radius: 6px;
    font-weight: 600;
  }

  .active-menu-item {
    color: $secondary-theme-color;
    font-weight: 500;
  }

  .sub-menu-item {
    padding: 10px 30px 10px 30px;
    cursor: pointer;
  }

  .comming-soon-section {
    width: 100%;
    background: $primary-theme-color;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffff;
    font-size: 12px;
    text-align: center;
    font-weight: 700;

    .comming-soon-tag {
      font-size: 9px;
      margin: 5px 10px;
      padding: 5px 3px;
      border: 2px solid #ffff;
      border-radius: 5px;
    }
  }

  .navbar-container {
    background-color: #ffff !important;
    height: 60px;
    padding: 0px 20px;
    box-shadow: 0px 0px 12px 1px #8888884f; // border-bottom: 1px solid #878684;
    position: fixed;
    width: calc(100% - 40px);
    z-index: 2;

    .list {
      display: flex;
      justify-content: space-between;

      .list-1 {
        // width: 50%;
      }

      .list-2 {
        // width: 35%;
        .retail-tabs {
          background-color: #ffffff;
          border: 1px solid #b5b5b5;
          margin-right: 20px;
          border-radius: 6px;
          height: 26px;
          align-items: center;
        }
      }
    }

    .vertical-line {
      height: 35px;
      border-left: 1px solid;
    }

    .signup-btn {
      font-size: 11px;
      font-weight: 600;
      padding: 5px 15px;
      text-transform: uppercase;
      margin-left: 20px;
      cursor: pointer;
    }

    .invester-btn {
      font-size: 12px;
      padding: 5px 15px;
      border-radius: 4px;
      border: 1px solid $secondary-theme-color;
      background-color: $secondary-theme-color;
      font-weight: 500;
      color: #ffff;
      cursor: pointer;
      -webkit-transition: all 0.4s ease-in-out;
      transition: all 0.4s ease-in-out;
    }

    .toggleBtn {
      display: none;
    }
  }

  .profile-pic {
    object-fit: cover;
    border-radius: 100%;
    margin-left: 20px;
    cursor: pointer;
  }

  .footer-nav {
    display: none;
    position: fixed;
    bottom: 0;
    padding: 10px 0 5px;
    left: 0;
    background-color: #ffff;
    width: 100%;
    box-shadow: 0px 0px 14px 1px #a3a3a3;
    z-index: 2;

    .footer-inner {
      display: flex;
      justify-content: space-around;
      align-items: center;
      // padding: 0 25px;

      .sections {
        text-align: center;

        img {
          width: 20px;
          cursor: pointer;
        }

        img:hover {
          filter: brightness(0.5);
        }

        .label {
          margin: 3px 0;
          font-size: 0.8rem;
          color: #525050;
        }
      }
    }
  }

  #mobileNav {
    display: none;
    position: fixed;
    color: #ffff;
    top: 0;
    left: 0;
    min-height: 100vh;
    transition: all 0.7s ease;
    overflow: hidden;
    background: #ffffff;
    width: 260px;
    // background: linear-gradient(0deg,
    //     #6664ab 0%,
    //     #4c4aab 34%,
    //     #534cd8 53%,
    //     #413de2 100%);
    z-index: 4;

    .invester-btn {
      font-size: 15px;
      padding: 8px 15px;
      border-radius: 10px;
      border: 1px solid #9c9af1;
      background-color: #9c9af1;
      font-weight: 500; // width: 100%;
      margin: 25px;
      cursor: pointer;
    }

    .active-invester-btn {
      font-size: 15px;
      padding: 8px 15px;
      border-radius: 10px;
      font-weight: 500;
      margin: 25px;
      border: 1px solid #f9da7f;
      background-color: #f9da7f;
      color: #000;
      cursor: pointer;
    }

    .my-account {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 15px;
    }

    .signup-btn {
      font-size: 12px;
      font-weight: 600;
      padding: 5px 15px;
      text-transform: uppercase;
      margin-left: 20px;
      cursor: pointer;
    }

    .bottom-line {
      border-bottom: 1px solid #ffff;
      margin-bottom: 30px;
    }

    .navbar-menu {
      font-size: 12px;
      margin: 15px 25px;
      color: #ffff;
    }

    .social-icon {
      width: 22px;
      padding: 10px 5px;
    }

    .follow-txt {
      margin: 0 10px;
      font-size: 12px;
    }

    .bottom-section {
      position: absolute;
      bottom: 15px;
      text-align: center;
    }
  }

  #overlay {
    position: fixed;
    display: none;
    width: 100%;
    height: 105vh;
    overflow: hidden;
    // top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #00000082;
    z-index: 3;
    cursor: pointer;
  }

  .navbar-menu {
    font-weight: 500;
    font-size: 12px;
    margin: 12px;
    white-space: nowrap;
    color: #464343;
    cursor: pointer;
  }

  .navbar-logo {
    width: 185px; // margin-right: 40px;
  }

  @media screen and (max-width: 1163px) {
    // .navbar-container .list .list-2 {
    //   width: 40%;
    // }
  }

  @media screen and (max-width: 1099px) {
    .offer-img-outer {
      display: flex;
    }
  }

  @media screen and (min-width: 1073px) {
    // .navbar-menu-section-desktop-view{
    //   display: flex;
    // }
    .navbar-menu-section-mobile-view {
      display: none;
    }
  }

  @media screen and (max-width: 978px) {
    .navbar-container {
      padding: 0px 20px;
    }

    .navbar-container .list .list-2,
    .navbar-container .list .list-1 {
      display: none;
    }

    .navbar-container .toggleBtn {
      display: flex;
      align-items: center;
    }
  }

  @media screen and (max-width: 979px) {
    .footer-nav {
      display: block;
    }
  }

  @media screen and (max-width: 500px) {
    .navbar-logo {
      width: 100px;
    }

    .offer-img-outer {
      .offer-img {
        width: 100%;
      }
    }

    .navbar-container {
      height: auto;
      padding: 15px;
      width: calc(100% - 30px);
    }
  }

  @media screen and (max-width: 1283px) {
    .navbar-menu-section-desktop-view {
      display: none;
    }

    .navbar-menu-section-mobile-view {
      display: block;
    }

    //   .navbar-menu {
    //     margin: 5px 5px;
    //   }
  }
}
</style>

<style lang="scss">
@import '../../css/variable.scss';
@import '../../css/common.scss';

.retail-navbar {
  .market-type-dropdown {
    background: #e72726;
    padding: 0px 7px 4px 11px;
    border-radius: 6px;
    margin-right: 6px;

    i.el-icon-arrow-down.el-icon--right,
    .active-menu-link {
      color: #ffff;
      font-weight: bolder;
    }

    .active-menu-link:hover {
      color: #ffff;
    }

    .el-dropdown {
      font-size: 12px;
    }
  }
}
</style>
